import React from 'react';
import FormCard from '../components/FormCard/FormCard';
import { Form, Button, Row, Col } from 'react-bootstrap';
import UploadImage from '../../client/components/ImageUpload';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { useState, useEffect } from 'react';
import axios from 'axios'
import ReactSelect from 'react-select';
import PopUpModal from './../../client/components/PopupModal';
import { Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom'

export default function EditTechStoreProducts() {
    const { user } = useSelector((state) => state.auth);
    const [stores, setStores] = useState();
    const [storeOptions, setStoreOptions] = useState();
    const [category, setCategory] = useState();
    const [categoryOptions, setCategoryOptions] = useState();
    const userId = user.seller_profile_id;
    const [brand, setBrand] = useState('')
    const [title, setTitle] = useState('')
    const [model, setModel] = useState('')
    const [storageSsd, setStorageSsd] = useState()
    const [storageHdd, setstorageHdd] = useState()
    const [ram, setRam] = useState()
    const [color, setColor] = useState()
    const [colorOptions, setcolorOptions] = useState();
    const [condition, setCondition] = useState()
    const [costPrice, setcostPrice] = useState()
    const [salePrice, setsalePrice] = useState()
    const [discountedPrice, setdiscountedPrice] = useState()
    const [quantity, setquantity] = useState()
    // const [processor, setprocessor] = useState()
    // const [generation, setgeneration] = useState()
    const [details, setdetails] = useState()
    const [file, setFile] = useState(null)
    const getFile = (f) => {
        setFile(f);
    }
    const [modal, setModal] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const params = useParams();
    const productId = params.id;
    const PF = process.env.REACT_APP_FIND_API_URL + "/images/";

    useEffect(() => {
        axios.post(process.env.REACT_APP_FIND_API_URL + `/smartTech-products/edit-smartTech-product/${productId}`,{}, {withCredentials: true}).then((res) => {
            console.log(res.data);
            const data = res.data.data.data[0];
            setBrand(data.brand)
            setTitle(data.name)
            setModel(data.model)
            setStorageSsd(data.storage_ssd)
            setstorageHdd(data.storage_hdd)
            setRam(data.ram)
            setColor({ value: data.color_id, label: data.color_name })
            setCondition({ value: data.condition_id, label: data.condition_name })
            setcostPrice(data.cost_price)
            setsalePrice(data.price)
            setdiscountedPrice(data.discounted_price)
            setquantity(data.quantity)
            setdetails(data.details)
            setFile(data.images)
            setStores({ value: data.seller_shop_id, label: data.seller_store_name })
            setCategory({ value: data.category_id, label: data.category_name })
        })
    }, [productId]);

    useEffect(() => {
        const getStores = async (id) => {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/store/get-store/${id}`, {withCredentials: true}).then((res) => {
                const getData = res.data.map((d) => ({ value: d.seller_shop_id, label: d.seller_store_name }))
                setStoreOptions(getData)
            })
        }
        if (userId) {
            getStores(userId)
        }
    }, [userId])

    useEffect(() => {
        const getCategory = async () => {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/category/get-tech-store`, {withCredentials: true}).then((res) => {
                const getData = res.data.data.map((d) => ({ value: d.category_id, label: d.category_name }))
                setCategoryOptions(getData)
            })
        }
        getCategory()
    }, []);

    useEffect(() => {
        const getColor = async () => {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/color/get`, {withCredentials: true}).then((res) => {
                const getData = res.data.map((d) => ({ value: d.color_id, label: d.color_name }))
                setcolorOptions(getData)
            })
        }
        getColor()
    }, []);

    // Set Title
    useEffect(() => {
        const gettitle = () => {
            setTitle(`${brand ? brand : ""} ${model ? ", " + model : ""}`);
        }
        gettitle();
    }, [brand, model]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newProduct = {
            shop_id: stores.value,
            category_id: category.value,
            brand: brand,
            name: title,
            model: model,
            storage_ssd: storageSsd,
            storage_hdd: storageHdd,
            ram: ram,
            color_id: color.value,
            color_name: color.label,
            condition_name: condition.label,
            condition_id: condition.value,
            cost_price: costPrice,
            price: salePrice,
            discounted_price: discountedPrice,
            quantity: quantity,
            details: details
        }
        if (file) {
            const data = new FormData();
            const filename = Date.now() + file.name;
            data.append("name", filename);
            data.append("file", file);
            newProduct.images = filename;
            try {
                await axios.post(process.env.REACT_APP_FIND_API_URL + "/upload", data, {withCredentials: true});
            } catch (error) {
                // console.log(error);
            }
        }
        console.log(newProduct);
        try {
            const res = await axios.patch(process.env.REACT_APP_FIND_API_URL + `/smartTech-products/update-smartTech-product/${productId}`, newProduct, {withCredentials: true});
            console.log(res);
            if (res.data) {
                setTimeout(() => setModal(false), 1000);
                setTimeout(() => navigate('/admin/dashboard'), 1000)
            }
        } catch (error) {
            console.log("err"+error);
            setError(error)
        }
    }

    return (
        <FormCard title="Add Products">
            {<PopUpModal title="Product Added Successfully." show={modal} onHide={() => setModal(false)} />}
            {error && <Alert severity="error">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Shop</Form.Label>
                            <Select placeholder="Select Store" options={storeOptions} onChange={(e) => setStores(e)} value={stores} />
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Category</Form.Label>
                            <Select placeholder="Select Category" options={categoryOptions} onChange={(e) => setCategory(e)} value={category} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control disabled type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Brand</Form.Label>
                            <Form.Control type="text" placeholder="Enter Brand" value={brand} onChange={(e) => setBrand(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Model</Form.Label>
                            <Form.Control type="text" placeholder="Enter Model" value={model} onChange={(e) => setModel(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Storage SDD</Form.Label>
                            <Form.Control type="number" placeholder="Enter Storage SDD" value={storageSsd} onChange={(e) => setStorageSsd(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Storage Hdd</Form.Label>
                            <Form.Control type="number" placeholder="Enter Storage Hdd" value={storageHdd} onChange={(e) => setstorageHdd(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Ram</Form.Label>
                            <Form.Control type="number" placeholder="Enter Ram" value={ram} onChange={(e) => setRam(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Color</Form.Label>
                            <Select placeholder="Select Color" options={colorOptions} onChange={(e) => setColor(e)} value={color} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Condition</Form.Label>
                            <ReactSelect placeholder="Select Condition" options={[{value: 1, label: 'New'}, {value: 0, label: 'Old'}]} value={condition} onChange={(e)=> setCondition(e)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Cost Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Cost Price" value={costPrice} onChange={(e) => setcostPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Sale Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Sale Price" value={salePrice} onChange={(e) => setsalePrice(e.target.value)} />
                        </Form.Group>
                    </Col><Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Discounted Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Discounted Price" value={discountedPrice} onChange={(e) => setdiscountedPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" placeholder="Enter Quantity" value={quantity} onChange={(e) => setquantity(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Product Details</Form.Label>
                            <Form.Control as="textarea" placeholder='Enter Product Details...' rows={3} value={details} onChange={(e) => setdetails(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        {file &&
                            <div>
                                <img className='rounded' width="130px" height="130" src={PF + file} alt={file} />
                            </div>
                        }
                        <UploadImage title="Image" getFile={getFile} />
                    </Col>
                </Row>
                <div>
                    <Button variant="primary" type="submit" className="w-100">
                        Submit
                    </Button>
                </div>
            </Form>
        </FormCard>
    )
}
